
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33982',
  depVersions: {
  "documents-public-ui": "static-1.33982",
  "client-types": "static-1.445",
  "documents-lib": "static-1.33987",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1930",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5398",
  "hs-test-utils": "static-1.7810",
  "hub-http": "static-1.6025",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11236",
  "I18n": "static-7.1571",
  "jasmine-immutable": "static-1.2823",
  "jasmine-runner": "static-1.6277",
  "lodash": "static-1.3",
  "quartz": "static-1.6742",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16454",
  "reporting-data": "static-1.66540",
  "reporting-testing-lib": "static-1.8473",
  "reporting-visualizations": "static-1.58616",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4570",
  "webpack-env": "static-1.54",
  "atom": "static-1.4874",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2290",
  "classnames": "static-2.10",
  "cssUtils": "static-1.733",
  "customer-data-filters-ui": "static-1.38925",
  "customer-data-objects": "static-1.7454",
  "customer-data-property-utils": "static-1.7882",
  "data-fetching-client": "static-1.9483",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4333",
  "flux-actions": "static-1.309",
  "FormsCommonComponents": "static-1.85299",
  "FormUrlGenerator": "static-2.4534",
  "foundations-components": "static-1.7530",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11544",
  "icons": "static-2.622",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6965",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3664",
  "property-translator": "static-1.5218",
  "quartz-config": "static-1.520",
  "quartz-core": "static-1.5961",
  "quick-fetch": "static-1.3739",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5177",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7965",
  "reference-resolvers-lite": "static-1.7899",
  "report-customization-components": "static-1.12507",
  "reporting-enablement": "static-1.22085",
  "reporting-reports": "static-1.66218",
  "reporting-snowflake": "static-1.55158",
  "reporting-ui-components": "static-2.63811",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4439",
  "sales-content-partitioning": "static-1.8740",
  "SalesContentIndexUI": "static-3.8907",
  "sanitize": "static-1.4279",
  "sanitize-text": "static-1.7945",
  "self-service-api": "static-1.10038",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1558",
  "signup-constants": "static-1.18412",
  "signup-ui-lego-core": "static-1.20422",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4575",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10799",
  "ui-addon-i18n": "static-1.10943",
  "ui-addon-react-router-dom": "static-1.9351",
  "ui-addon-upgrades": "static-9.17664",
  "ui-asset-management-lib": "static-1.10713",
  "ui-images": "static-2.1093",
  "UIComponents": "static-3.8183",
  "usage-tracker": "static-1.7139",
  "usage-tracker-container": "static-1.7129",
  "usage-tracker-core": "static-1.6989",
  "usage-tracker-public": "static-1.6950",
  "viral-links-lib": "static-1.6840",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3231",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3019",
  "quartz-webpack": "static-1.2966",
  "ai-components-ui-library": "static-1.8358",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4641",
  "foundations-theming": "static-1.4214",
  "quartz-auth": "static-1.417",
  "ui-business-units-lib": "static-1.8831",
  "usage-tracker-session-replay": "static-1.4825",
  "foundations-theming-base": "static-1.3199",
  "HeadJS": "static-2.710",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2921",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4131",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7729",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3421",
  "persist-promise": "static-1.3513",
  "reporting-client-types": "static-1.2385",
  "foundations-components-legacy": "static-1.555",
  "hs-story-utils": "static-1.9232",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9484",
  "hubspotter-http": "static-1.4482",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7052",
  "crm-message-bus": "static-1.42381",
  "customer-data-filters-ui-msw-helpers": "static-1.21360",
  "customer-data-objects-ui-components": "static-1.12812",
  "customer-data-reference-ui-components": "static-1.12950",
  "customer-data-ui-utilities": "static-1.9628",
  "framework-builder-read-service-client": "static-1.3837",
  "framework-data-schema-quick-fetch": "static-1.6583",
  "framework-data-schema-resolvers": "static-1.6678",
  "inbound-db-properties-service-client": "static-1.3679",
  "multi-account-reference-resolvers": "static-1.778",
  "onboarding-tours": "static-1.16266",
  "reporting-datasets-permissions-lib": "static-1.13063",
  "ui-addon-teams": "static-1.21248",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67636",
  "customer-data-properties": "static-1.50813",
  "forms-ai-lib": "static-1.4015",
  "forms-utils-lib": "static-1.12172",
  "foundations-components-test-utils": "static-1.5013",
  "react-dnd-compat": "static-1.4425",
  "react-tinymce": "static-1.54633",
  "tinymce-config": "static-2.53759",
  "ui-gdpr-components": "static-1.10152",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3799",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1211",
  "ui-fonts": "static-1.498",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.795",
  "mobile-manifest-mixins": "static-1.483",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.407",
  "quartz-i18n": "static-1.417",
  "quartz-routing": "static-1.172",
  "quartz-test": "static-1.417",
  "quartz-tracking": "static-1.121",
  "batch-promise": "static-1.1356",
  "external-options-client-types": "static-1.3988",
  "react-colorpicker": "static-2.10014",
  "copilot-toolkit": "static-1.10542",
  "data-quality-ui-library": "static-1.12330",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40667",
  "reporting-insights-lib": "static-1.1177",
  "reporting-plugins": "static-1.9989",
  "ui-addon-draggable-compat": "static-2.4058",
  "ui-addon-opt": "static-4.8189",
  "ui-shepherd-react": "static-3.9950",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24742",
  "hubspot-apollo-client": "static-1.4686",
  "sales-templates-service-types-lib": "static-1.3995",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5489",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3908",
  "timezone-utils": "static-2.5049",
  "bender-build-tools": "static-1.2947",
  "chatspot-core": "static-1.20331",
  "chirp-fetch": "static-1.1687",
  "bend-plugin-foundations-theming": "static-1.2697",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9482",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3627",
  "crm-pipelines-api-client-types": "static-1.3968",
  "multi-currency-client-types": "static-1.3521",
  "getting-started-shared-tasks": "static-1.17897",
  "growth-data-modal": "static-1.5161",
  "growth-onboarding-confetti": "static-1.2876",
  "growth-onboarding-next-action-utils": "static-1.1303",
  "navigation-components": "static-1.17283",
  "onboarding-tours-client": "static-1.4480",
  "onboarding-tours-utils": "static-1.332",
  "ui-shepherd-tracker": "static-1.7331",
  "ui-universal-auth": "static-1.8706",
  "user-context": "static-1.4904",
  "cms-field-types": "static-1.4611",
  "content-icons-ui": "static-1.2155",
  "integrations-lib": "static-1.15430",
  "calling-global-api": "static-1.63683",
  "calling-internal-common": "static-1.31098",
  "calling-lifecycle-internal": "static-1.65065",
  "calling-lifecycle-messages": "static-1.57359",
  "commerce-products-lib": "static-1.8873",
  "crm-links": "static-1.6070",
  "file-manager-components": "static-1.22898",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.483",
  "inbounddb-objects-service-types": "static-1.4053",
  "meetings-icalendar-utils-lib": "static-1.438",
  "object-builder-ui-client": "static-1.47995",
  "pipeline-validation-client-types": "static-1.3790",
  "property-value-citations": "static-1.1427",
  "pulse": "static-1.316",
  "smart-property-lib": "static-1.5921",
  "tiered-pricing": "static-1.835",
  "ui-addon-iframeable": "static-1.8849",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19474",
  "tinymce-themes": "static-1.55729",
  "data-token-picker": "static-1.16047",
  "hub-http-contrib": "static-1.2848",
  "interframe": "static-3.4595",
  "tinymce-data": "static-1.39844",
  "tinymce-plugins": "static-1.56873",
  "ui-addon-sales-email": "static-1.5018",
  "magpie-lib": "static-1.5398",
  "magpie-types": "static-1.4858",
  "simple-logging-lib": "static-1.2855",
  "content-assistance-lib": "static-1.7455",
  "dashboard-lib": "static-1.80643",
  "ExportDialog": "static-6.10191",
  "hubspot-prosemirror": "static-1.17617",
  "hubspot-prosemirror-plugins": "static-1.17609",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8496",
  "campaign-roi-lib": "static-1.8286",
  "feedback-loader": "static-1.28861",
  "onboarding-scopes": "static-1.6268",
  "apollo-link-hub-http": "static-2.4454",
  "hubspot-apollo-cache": "static-1.145",
  "growth-monetization-service-types": "static-1.4318",
  "nav-client-types": "static-1.2162",
  "purchase-motions-api": "static-1.5492",
  "trials-service-types": "static-1.3719",
  "growth-onboarding-next-action-components": "static-1.1331",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.530",
  "unified-auth-core-lib": "static-1.501",
  "getting-started-shared-tasks-store": "static-1.17015",
  "integrations-error-boundary-lib": "static-1.12845",
  "integrations-tracking-lib": "static-1.5393",
  "native-integrations-shared-strings": "static-1.7593",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10176",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31104",
  "shared-worker-versioning": "static-1.10843",
  "calling-usage-tracker": "static-1.6345",
  "voice-sms-access-library": "static-1.261",
  "customer-data-tracking": "static-1.6687",
  "commerce-permissions": "static-1.563",
  "products-iframe-lib": "static-1.7329",
  "products-ui-components-shared-msw-handlers": "static-1.9866",
  "location-customization-utils-lib": "static-1.8576",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3959",
  "video-components-external": "static-1.10575",
  "video-data-lib": "static-1.34233",
  "directed-graph": "static-1.741",
  "event-emitter": "static-1.752",
  "breeze-intelligence-kit": "static-1.5327",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9567",
  "fsm": "static-1.3535",
  "policy-lib": "static-1.6588",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9630",
  "navigation-messaging": "static-1.6610",
  "FileManagerLib": "static-1.38538",
  "NamespacedHubStyle": "static-2.8900",
  "FileManagerCore": "static-1.38397",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12038",
  "layout-dnd-utils": "static-1.11013",
  "react-codemirror": "static-1.10431",
  "ui-addon-emoji-picker": "static-1.9693",
  "ui-brand-identity-lib": "static-1.13901",
  "ui-addon-video-player": "static-1.8501",
  "ui-coaching-tips": "static-1.27956",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8373",
  "payment-link-components": "static-1.22953",
  "EmailSignatureEditor": "static-1.23917",
  "eligibility-engine-service-types": "static-1.3000",
  "universal-page-editor-lib": "static-1.2804",
  "calling-orchestration-schema": "static-1.35038",
  "sales-views-client-types": "static-1.4092",
  "crm-record-cards-service-types": "static-1.3456",
  "content-media-composition-data-lib": "static-1.11467",
  "content-media-compositions": "static-2.15474",
  "media-bridge-lib": "static-1.18570",
  "trellis-story-utils": "static-1.4326",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5619",
  "FileManagerImages": "static-1.36049",
  "video-components": "static-1.12578",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4337",
  "video-embed": "static-1.35067",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67711",
  "layout-data-lib": "static-1.9338",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6388",
  "commerce-tours-lib": "static-1.5725",
  "growth-onboarding-reliability": "static-1.4891",
  "sales-checkout-service-client": "static-1.3473",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21312",
  "sales-email-signature-service-client": "static-1.3649",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21349",
  "outpost": "static-1.4009",
  "advanced-menus-core": "static-1.14820",
  "advanced-menus-lib": "static-1.11794",
  "ui-memberships-settings-lib": "static-1.33438",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14819",
  "simple-menus-lib": "static-1.16336"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33982",
  "client-types": "/client-types/static-1.445",
  "documents-lib": "/documents-lib/static-1.33987",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1930",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5398",
  "hs-test-utils": "/hs-test-utils/static-1.7810",
  "hub-http": "/hub-http/static-1.6025",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11236",
  "I18n": "/I18n/static-7.1571",
  "jasmine-immutable": "/jasmine-immutable/static-1.2823",
  "jasmine-runner": "/jasmine-runner/static-1.6277",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6742",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16454",
  "reporting-data": "/reporting-data/static-1.66540",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8473",
  "reporting-visualizations": "/reporting-visualizations/static-1.58616",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4570",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4874",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2290",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.733",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38925",
  "customer-data-objects": "/customer-data-objects/static-1.7454",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7882",
  "data-fetching-client": "/data-fetching-client/static-1.9483",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4333",
  "flux-actions": "/flux-actions/static-1.309",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85299",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4534",
  "foundations-components": "/foundations-components/static-1.7530",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11544",
  "icons": "/icons/static-2.622",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6965",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3664",
  "property-translator": "/property-translator/static-1.5218",
  "quartz-config": "/quartz-config/static-1.520",
  "quartz-core": "/quartz-core/static-1.5961",
  "quick-fetch": "/quick-fetch/static-1.3739",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5177",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7965",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7899",
  "report-customization-components": "/report-customization-components/static-1.12507",
  "reporting-enablement": "/reporting-enablement/static-1.22085",
  "reporting-reports": "/reporting-reports/static-1.66218",
  "reporting-snowflake": "/reporting-snowflake/static-1.55158",
  "reporting-ui-components": "/reporting-ui-components/static-2.63811",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4439",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8740",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8907",
  "sanitize": "/sanitize/static-1.4279",
  "sanitize-text": "/sanitize-text/static-1.7945",
  "self-service-api": "/self-service-api/static-1.10038",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1558",
  "signup-constants": "/signup-constants/static-1.18412",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20422",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4575",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10799",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10943",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9351",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17664",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10713",
  "ui-images": "/ui-images/static-2.1093",
  "UIComponents": "/UIComponents/static-3.8183",
  "usage-tracker": "/usage-tracker/static-1.7139",
  "usage-tracker-container": "/usage-tracker-container/static-1.7129",
  "usage-tracker-core": "/usage-tracker-core/static-1.6989",
  "usage-tracker-public": "/usage-tracker-public/static-1.6950",
  "viral-links-lib": "/viral-links-lib/static-1.6840",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3231",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3019",
  "quartz-webpack": "/quartz-webpack/static-1.2966",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8358",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4641",
  "foundations-theming": "/foundations-theming/static-1.4214",
  "quartz-auth": "/quartz-auth/static-1.417",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8831",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4825",
  "foundations-theming-base": "/foundations-theming-base/static-1.3199",
  "HeadJS": "/HeadJS/static-2.710",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2921",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4131",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7729",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3421",
  "persist-promise": "/persist-promise/static-1.3513",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.555",
  "hs-story-utils": "/hs-story-utils/static-1.9232",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9484",
  "hubspotter-http": "/hubspotter-http/static-1.4482",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7052",
  "crm-message-bus": "/crm-message-bus/static-1.42381",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21360",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12812",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12950",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9628",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3837",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6583",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6678",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3679",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.778",
  "onboarding-tours": "/onboarding-tours/static-1.16266",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13063",
  "ui-addon-teams": "/ui-addon-teams/static-1.21248",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67636",
  "customer-data-properties": "/customer-data-properties/static-1.50813",
  "forms-ai-lib": "/forms-ai-lib/static-1.4015",
  "forms-utils-lib": "/forms-utils-lib/static-1.12172",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5013",
  "react-dnd-compat": "/react-dnd-compat/static-1.4425",
  "react-tinymce": "/react-tinymce/static-1.54633",
  "tinymce-config": "/tinymce-config/static-2.53759",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10152",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3799",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1211",
  "ui-fonts": "/ui-fonts/static-1.498",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.795",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.483",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.407",
  "quartz-i18n": "/quartz-i18n/static-1.417",
  "quartz-routing": "/quartz-routing/static-1.172",
  "quartz-test": "/quartz-test/static-1.417",
  "quartz-tracking": "/quartz-tracking/static-1.121",
  "batch-promise": "/batch-promise/static-1.1356",
  "external-options-client-types": "/external-options-client-types/static-1.3988",
  "react-colorpicker": "/react-colorpicker/static-2.10014",
  "copilot-toolkit": "/copilot-toolkit/static-1.10542",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12330",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40667",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1177",
  "reporting-plugins": "/reporting-plugins/static-1.9989",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4058",
  "ui-addon-opt": "/ui-addon-opt/static-4.8189",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9950",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24742",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4686",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3995",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5489",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3908",
  "timezone-utils": "/timezone-utils/static-2.5049",
  "bender-build-tools": "/bender-build-tools/static-1.2947",
  "chatspot-core": "/chatspot-core/static-1.20331",
  "chirp-fetch": "/chirp-fetch/static-1.1687",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2697",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9482",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3627",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3968",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3521",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17897",
  "growth-data-modal": "/growth-data-modal/static-1.5161",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2876",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1303",
  "navigation-components": "/navigation-components/static-1.17283",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4480",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.332",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7331",
  "ui-universal-auth": "/ui-universal-auth/static-1.8706",
  "user-context": "/user-context/static-1.4904",
  "cms-field-types": "/cms-field-types/static-1.4611",
  "content-icons-ui": "/content-icons-ui/static-1.2155",
  "integrations-lib": "/integrations-lib/static-1.15430",
  "calling-global-api": "/calling-global-api/static-1.63683",
  "calling-internal-common": "/calling-internal-common/static-1.31098",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65065",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57359",
  "commerce-products-lib": "/commerce-products-lib/static-1.8873",
  "crm-links": "/crm-links/static-1.6070",
  "file-manager-components": "/file-manager-components/static-1.22898",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.483",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4053",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.438",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47995",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3790",
  "property-value-citations": "/property-value-citations/static-1.1427",
  "pulse": "/pulse/static-1.316",
  "smart-property-lib": "/smart-property-lib/static-1.5921",
  "tiered-pricing": "/tiered-pricing/static-1.835",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8849",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19474",
  "tinymce-themes": "/tinymce-themes/static-1.55729",
  "data-token-picker": "/data-token-picker/static-1.16047",
  "hub-http-contrib": "/hub-http-contrib/static-1.2848",
  "interframe": "/interframe/static-3.4595",
  "tinymce-data": "/tinymce-data/static-1.39844",
  "tinymce-plugins": "/tinymce-plugins/static-1.56873",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5018",
  "magpie-lib": "/magpie-lib/static-1.5398",
  "magpie-types": "/magpie-types/static-1.4858",
  "simple-logging-lib": "/simple-logging-lib/static-1.2855",
  "content-assistance-lib": "/content-assistance-lib/static-1.7455",
  "dashboard-lib": "/dashboard-lib/static-1.80643",
  "ExportDialog": "/ExportDialog/static-6.10191",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17617",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17609",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8496",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8286",
  "feedback-loader": "/feedback-loader/static-1.28861",
  "onboarding-scopes": "/onboarding-scopes/static-1.6268",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4454",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.145",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4318",
  "nav-client-types": "/nav-client-types/static-1.2162",
  "purchase-motions-api": "/purchase-motions-api/static-1.5492",
  "trials-service-types": "/trials-service-types/static-1.3719",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1331",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.530",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.501",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17015",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12845",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5393",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7593",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10176",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31104",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10843",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6345",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.261",
  "customer-data-tracking": "/customer-data-tracking/static-1.6687",
  "commerce-permissions": "/commerce-permissions/static-1.563",
  "products-iframe-lib": "/products-iframe-lib/static-1.7329",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9866",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8576",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3959",
  "video-components-external": "/video-components-external/static-1.10575",
  "video-data-lib": "/video-data-lib/static-1.34233",
  "directed-graph": "/directed-graph/static-1.741",
  "event-emitter": "/event-emitter/static-1.752",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5327",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9567",
  "fsm": "/fsm/static-1.3535",
  "policy-lib": "/policy-lib/static-1.6588",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9630",
  "navigation-messaging": "/navigation-messaging/static-1.6610",
  "FileManagerLib": "/FileManagerLib/static-1.38538",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8900",
  "FileManagerCore": "/FileManagerCore/static-1.38397",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12038",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11013",
  "react-codemirror": "/react-codemirror/static-1.10431",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9693",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13901",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8501",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27956",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8373",
  "payment-link-components": "/payment-link-components/static-1.22953",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23917",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3000",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2804",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35038",
  "sales-views-client-types": "/sales-views-client-types/static-1.4092",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3456",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11467",
  "content-media-compositions": "/content-media-compositions/static-2.15474",
  "media-bridge-lib": "/media-bridge-lib/static-1.18570",
  "trellis-story-utils": "/trellis-story-utils/static-1.4326",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5619",
  "FileManagerImages": "/FileManagerImages/static-1.36049",
  "video-components": "/video-components/static-1.12578",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4337",
  "video-embed": "/video-embed/static-1.35067",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67711",
  "layout-data-lib": "/layout-data-lib/static-1.9338",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6388",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5725",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4891",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3473",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21312",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3649",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21349",
  "outpost": "/outpost/static-1.4009",
  "advanced-menus-core": "/advanced-menus-core/static-1.14820",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11794",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33438",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14819",
  "simple-menus-lib": "/simple-menus-lib/static-1.16336"
}
};
